import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [
    AsyncPipe
  ],
  templateUrl: './toast.html',
  styleUrl: './toast.css',
  // animations: [
  //   trigger('slideIn', [
  //     transition(':enter', [
  //       style({transform: 'translateX(400px)', opacity: 0}),
  //       animate('300ms ease-out', style({transform: 'translateX(0)', opacity: 1}))
  //     ]),
  //     transition(':leave', [
  //       animate('300ms ease-in', style({transform: 'translateX(400px)', opacity: 0}))
  //     ])
  //   ])
  // ]
})
export class Toast {
  private toastService = inject(ToastService);
  toasts$ = this.toastService.toasts$;

  onClose(id: string) {
    this.toastService.remove(id);
  }

  getIcon(type: string): string {
    const icons: Record<string, string> = {
      success: 'check_circle',
      error: 'error',
      warning: 'warning',
      info: 'info'
    };
    return icons[type] || 'info';
  }

}
